(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/* global Y */
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function extend(Y /* :any */) {
  var YMap = function () {
    /* ::
    _model: Id;
    os: Y.AbstractDatabase;
    map: Object;
    contents: any;
    opContents: Object;
    eventHandler: Function;
    */

    function YMap(os, model, contents, opContents) {
      var _this = this;

      _classCallCheck(this, YMap);

      this._model = model.id;
      this.os = os;
      this.map = Y.utils.copyObject(model.map);
      this.contents = contents;
      this.opContents = opContents;
      this.eventHandler = new Y.utils.EventHandler(function (ops) {
        var userEvents = [];
        for (var i in ops) {
          var op = ops[i];
          var oldValue;
          // key is the name to use to access (op)content
          var key = op.struct === 'Delete' ? op.key : op.parentSub;

          // compute oldValue
          if (_this.opContents[key] != null) {
            (function () {
              var prevType = _this.opContents[key];
              oldValue = function oldValue() {
                // eslint-disable-line
                return new Promise(function (resolve) {
                  _this.os.requestTransaction(regeneratorRuntime.mark(function _callee() {
                    var type;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            return _context.delegateYield(this.getType(prevType), 't0', 1);

                          case 1:
                            type = _context.t0;

                            resolve(type);

                          case 3:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, this);
                  }));
                });
              };
            })();
          } else {
            oldValue = _this.contents[key];
          }
          // compute op event
          if (op.struct === 'Insert') {
            if (op.left === null) {
              if (op.opContent != null) {
                delete _this.contents[key];
                if (op.deleted) {
                  delete _this.opContents[key];
                } else {
                  _this.opContents[key] = op.opContent;
                }
              } else {
                delete _this.opContents[key];
                if (op.deleted) {
                  delete _this.contents[key];
                } else {
                  _this.contents[key] = op.content;
                }
              }
              _this.map[key] = op.id;
              var insertEvent;
              if (oldValue === undefined) {
                insertEvent = {
                  name: key,
                  object: _this,
                  type: 'add'
                };
              } else {
                insertEvent = {
                  name: key,
                  object: _this,
                  oldValue: oldValue,
                  type: 'update'
                };
              }
              userEvents.push(insertEvent);
            }
          } else if (op.struct === 'Delete') {
            if (Y.utils.compareIds(_this.map[key], op.target)) {
              delete _this.opContents[key];
              delete _this.contents[key];
              var deleteEvent = {
                name: key,
                object: _this,
                oldValue: oldValue,
                type: 'delete'
              };
              userEvents.push(deleteEvent);
            }
          } else {
            throw new Error('Unexpected Operation!');
          }
        }
        if (userEvents.length > 0) {
          _this.eventHandler.callEventListeners(userEvents);
        }
      });
    }

    _createClass(YMap, [{
      key: 'get',
      value: function get(key) {
        var _this2 = this;

        // return property.
        // if property does not exist, return null
        // if property is a type, return a promise
        if (key == null) {
          throw new Error('You must specify key!');
        }
        if (this.opContents[key] == null) {
          return this.contents[key];
        } else {
          return new Promise(function (resolve) {
            var oid = _this2.opContents[key];
            _this2.os.requestTransaction(regeneratorRuntime.mark(function _callee2() {
              var type;
              return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      return _context2.delegateYield(this.getType(oid), 't0', 1);

                    case 1:
                      type = _context2.t0;

                      resolve(type);

                    case 3:
                    case 'end':
                      return _context2.stop();
                  }
                }
              }, _callee2, this);
            }));
          });
        }
      }
      /*
        If there is a primitive (not a custom type), then return it.
        Returns all primitive values, if propertyName is specified!
        Note: modifying the return value could result in inconsistencies!
          -- so make sure to copy it first!
      */

    }, {
      key: 'getPrimitive',
      value: function getPrimitive(key) {
        if (key == null) {
          return Y.utils.copyObject(this.contents);
        } else {
          return this.contents[key];
        }
      }
    }, {
      key: 'delete',
      value: function _delete(key) {
        var right = this.map[key];
        if (right != null) {
          var del = {
            target: right,
            struct: 'Delete'
          };
          var eventHandler = this.eventHandler;
          var modDel = Y.utils.copyObject(del);
          modDel.key = key;
          eventHandler.awaitAndPrematurelyCall([modDel]);
          this.os.requestTransaction(regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    return _context3.delegateYield(this.applyCreatedOperations([del]), 't0', 1);

                  case 1:
                    eventHandler.awaitedDeletes(1);

                  case 2:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, this);
          }));
        }
      }
    }, {
      key: 'set',
      value: function set(key, value) {
        var _this3 = this;

        // set property.
        // if property is a type, return a promise
        // if not, apply immediately on this type an call event

        var right = this.map[key] || null;
        var insert /* :any */ = {
          left: null,
          right: right,
          origin: null,
          parent: this._model,
          parentSub: key,
          struct: 'Insert'
        };
        return new Promise(function (resolve) {
          if (value instanceof Y.utils.CustomType) {
            // construct a new type
            _this3.os.requestTransaction(regeneratorRuntime.mark(function _callee4() {
              var type;
              return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      return _context4.delegateYield(this.createType(value), 't0', 1);

                    case 1:
                      type = _context4.t0;

                      insert.opContent = type._model;
                      insert.id = this.store.getNextOpId();
                      return _context4.delegateYield(this.applyCreatedOperations([insert]), 't1', 5);

                    case 5:
                      resolve(type);

                    case 6:
                    case 'end':
                      return _context4.stop();
                  }
                }
              }, _callee4, this);
            }));
          } else {
            insert.content = value;
            insert.id = _this3.os.getNextOpId();
            var eventHandler = _this3.eventHandler;
            eventHandler.awaitAndPrematurelyCall([insert]);
            _this3.os.requestTransaction(regeneratorRuntime.mark(function _callee5() {
              return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      return _context5.delegateYield(this.applyCreatedOperations([insert]), 't0', 1);

                    case 1:
                      eventHandler.awaitedInserts(1);

                    case 2:
                    case 'end':
                      return _context5.stop();
                  }
                }
              }, _callee5, this);
            }));
            resolve(value);
          }
        });
      }
    }, {
      key: 'observe',
      value: function observe(f) {
        this.eventHandler.addEventListener(f);
      }
    }, {
      key: 'unobserve',
      value: function unobserve(f) {
        this.eventHandler.removeEventListener(f);
      }
      /*
        Observe a path.
          E.g.
        ```
        o.set('textarea', Y.TextBind)
        o.observePath(['textarea'], function(t){
          // is called whenever textarea is replaced
          t.bind(textarea)
        })
          returns a Promise that contains a function that removes the observer from the path.
      */

    }, {
      key: 'observePath',
      value: function observePath(path, f) {
        var self = this;
        function observeProperty(events) {
          // call f whenever path changes
          for (var i = 0; i < events.length; i++) {
            var event = events[i];
            if (event.name === propertyName) {
              // call this also for delete events!
              var property = self.get(propertyName);
              if (property instanceof Promise) {
                property.then(f);
              } else {
                f(property);
              }
            }
          }
        }

        if (path.length < 1) {
          throw new Error('Path must contain at least one element!');
        } else if (path.length === 1) {
          var propertyName = path[0];
          var property = self.get(propertyName);
          if (property instanceof Promise) {
            property.then(f);
          } else {
            f(property);
          }
          this.observe(observeProperty);
          return Promise.resolve(function () {
            self.unobserve(f);
          });
        } else {
          var deleteChildObservers;
          var resetObserverPath = function resetObserverPath() {
            var promise = self.get(path[0]);
            if (!promise instanceof Promise) {
              // its either not defined or a primitive value
              promise = self.set(path[0], Y.Map);
            }
            return promise.then(function (map) {
              return map.observePath(path.slice(1), f);
            }).then(function (_deleteChildObservers) {
              // update deleteChildObservers
              deleteChildObservers = _deleteChildObservers;
              return Promise.resolve(); // Promise does not return anything
            });
          };
          var observer = function observer(events) {
            for (var e in events) {
              var event = events[e];
              if (event.name === path[0]) {
                if (deleteChildObservers != null) {
                  deleteChildObservers();
                }
                if (event.type === 'add' || event.type === 'update') {
                  resetObserverPath();
                }
                // TODO: what about the delete events?
              }
            }
          };
          self.observe(observer);
          return resetObserverPath().then(
          // this promise contains a function that deletes all the child observers
          // and how to unobserve the observe from this object
          new Promise.resolve(function () {
            // eslint-disable-line
            if (deleteChildObservers != null) {
              deleteChildObservers();
            }
            self.unobserve(observer);
          }));
        }
      }
    }, {
      key: '_changed',
      value: regeneratorRuntime.mark(function _changed(transaction, op) {
        var target;
        return regeneratorRuntime.wrap(function _changed$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(op.struct === 'Delete')) {
                  _context6.next = 4;
                  break;
                }

                return _context6.delegateYield(transaction.getOperation(op.target), 't0', 2);

              case 2:
                target = _context6.t0;

                op.key = target.parentSub;

              case 4:
                this.eventHandler.receivedOp(op);

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _changed, this);
      })
    }]);

    return YMap;
  }();

  Y.extend('Map', new Y.utils.CustomType({
    name: 'Map',
    class: YMap,
    struct: 'Map',
    initType: regeneratorRuntime.mark(function YMapInitializer(os, model) {
      var contents, opContents, map, name, op;
      return regeneratorRuntime.wrap(function YMapInitializer$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              contents = {};
              opContents = {};
              map = model.map;
              _context7.t0 = regeneratorRuntime.keys(map);

            case 4:
              if ((_context7.t1 = _context7.t0()).done) {
                _context7.next = 11;
                break;
              }

              name = _context7.t1.value;
              return _context7.delegateYield(this.getOperation(map[name]), 't2', 7);

            case 7:
              op = _context7.t2;

              if (op.opContent != null) {
                opContents[name] = op.opContent;
              } else {
                contents[name] = op.content;
              }
              _context7.next = 4;
              break;

            case 11:
              return _context7.abrupt('return', new YMap(os, model, contents, opContents));

            case 12:
            case 'end':
              return _context7.stop();
          }
        }
      }, YMapInitializer, this);
    })
  }));
}

module.exports = extend;
if (typeof Y !== 'undefined') {
  extend(Y);
}

},{}]},{},[1])

